/**
 * Configuration centralisée de l'API pour le back-office
 * Ce fichier évite les URLs et UUIDs hardcodés dans le code
 */

// URL de base de l'API - TOUJOURS utiliser les variables d'environnement
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';
export const API_SERVER_URL = process.env.REACT_APP_API_SERVER || API_BASE_URL.replace('/api', '');

/**
 * Récupère l'ID du tenant depuis le stockage local ou le token JWT
 * NE JAMAIS hardcoder d'UUID de tenant
 * @returns {string|null} L'ID du tenant ou null si non trouvé
 */
export const getTenantId = () => {
  // D'abord vérifier dans localStorage
  const storedTenantId = localStorage.getItem('tenant_id');
  if (storedTenantId) {
    return storedTenantId;
  }

  // Sinon, essayer d'extraire du token JWT
  const token = localStorage.getItem('token');
  if (token) {
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      if (payload.tenant_id) {
        // Sauvegarder pour les prochaines utilisations
        localStorage.setItem('tenant_id', payload.tenant_id);
        return payload.tenant_id;
      }
    } catch (e) {
      console.warn('Erreur lors du parsing du token JWT:', e);
    }
  }

  // Essayer de récupérer depuis l'objet user
  const userData = localStorage.getItem('user');
  if (userData) {
    try {
      const user = JSON.parse(userData);
      if (user.tenant_id) {
        return user.tenant_id;
      }
    } catch (e) {
      console.warn('Erreur lors du parsing des données utilisateur:', e);
    }
  }

  console.warn('⚠️ Aucun tenant_id trouvé - l\'utilisateur doit être connecté');
  return null;
};

/**
 * Construit l'URL complète pour une ressource statique (image, document, etc.)
 * @param {string} path - Le chemin relatif de la ressource
 * @returns {string} L'URL complète
 */
export const getStaticUrl = (path) => {
  if (!path) return '';
  if (path.startsWith('http')) return path;
  return `${API_SERVER_URL}${path.startsWith('/') ? '' : '/'}${path}`;
};

/**
 * Récupère les headers d'authentification standard
 * @returns {object} Les headers avec token et tenant_id
 */
export const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  const tenantId = getTenantId();

  const headers = {
    'Content-Type': 'application/json'
  };

  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  if (tenantId) {
    headers['x-tenant-id'] = tenantId;
  }

  return headers;
};
